/**
 * (スケジュール一覧) カレンダー部 トグル表示
 */

/* Import Modules */
import $ from "jquery";

/* Define Variables */
const calendarId = "#schedule_index_calendar";
const calendarTitleId = "#schedule_index_calendar_title";

/* Define Function */
const toggleCalendar = () => {
  if (window.matchMedia("(min-width: 1200px)").matches) {
    $("#schedule_index_calendar").toggle("slow");
  }
};

export const triggerClickCalendarTitle = () => {
  if (window.matchMedia("(min-width: 1200px)").matches) {
    $("#schedule_index_calendar_title").trigger("click");
  }
};

/* Define Event */
export const toggleCalendarClickEvent = () => {
  $("#schedule_index_calendar_title").on("click", function () {
    toggleCalendar();
  });
};

/**
 * グローバル関数を定義
 */
(window as any).triggerClickCalendarTitle = triggerClickCalendarTitle;
(window as any).toggleCalendarClickEvent = toggleCalendarClickEvent;
